export const OAUTH_PROVIDER = {
  KAKAO: 'KAKAO',
  APPLE: 'APPLE',
  LINE: 'LINE',
  GOOGLE: 'GOOGLE',
} as const
